import React, { forwardRef } from 'react';
const Lamp = forwardRef((props, ref) => (React.createElement("svg", { viewBox: "0 0 24 24", height: "1em", role: "img", ref: ref, ...props },
    React.createElement("g", { fill: "currentColor" },
        React.createElement("path", { d: "M12 5.25v13.5H8.25c-3.75 0-6.75-3-6.75-6.75s3-6.75 6.75-6.75zm1.5-1.5H8.25A8.226 8.226 0 0 0 0 12a8.226 8.226 0 0 0 8.25 8.25h5.25zM24 11.25h-6v1.5h6zM16.436 15.064l-1.061 1.06 4.243 4.244 1.06-1.061zM19.618 3.632l-4.243 4.243 1.06 1.06 4.243-4.242z" })))));
Lamp.displayName = 'Lamp';
// @ts-ignore;
const iconData = {
    glyph: Lamp,
    group: 'car',
};
export default iconData;
